import React from "react"

import { arrayOf, shape, number, func, bool, string } from 'prop-types'

import { useIs3dPrintModel } from 'Pods/ItemPage/TopSection/hooks/useTopSectionProps'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import { useCaseShape, printerTypeOptionShape } from "../../Utils/propTypes"
import UseCaseMediaViewer from "../UseCaseMediaViewer/UseCaseMediaViewer"

function MediaContainer({
  canDeleteUseCase,
  canEditUseCase,
  canUseLikeFeature,
  isFetchingPrinterTypes = false,
  onApprove,
  onDelete,
  onEditUseCase,
  onLike,
  onReject,
  onUnlike,
  onUseCaseClick = null,
  printerTypeOptions = EMPTY_ARRAY,
  useCases,
  userIsAllowedToModerate,
  initialMediaIndex = 0,
  isGalleryView = false,
  mediaContainerIndexes = EMPTY_OBJECT,
  onFullscreenClick = null,
  canDownloadSlicerFile = true,
  currentUsername = null,
  onShowNotification,
  isUpdating = false,
  onEditingChange = null,
}) {
  const is3dPrintModel = useIs3dPrintModel()
  if (useCases.length === 0) {
    return (
      <div className="use-cases-area__media-container">
        <div className="use-cases-area__media-container-empty">
          <h3 className="use-cases-area__media-container-empty-title">
            {is3dPrintModel ? 'No 3D Makes yet' : 'No Use Cases yet'}
          </h3>
          <p className="use-cases-area__media-container-empty-subtitle">
            {
              is3dPrintModel
                ? 'Share how this model looks when 3D printed! Upload your 3D Make to inspire others.'
                : 'Be the first to showcase how this 3D model can be used in real-world projects. ' +
                    'Upload your images or videos to inspire others.'
            }
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="use-cases-area__media-container">
      <div className="use-cases-area__media-container-grid">
        {useCases.map((useCase) => {
          const canDelete = canDeleteUseCase(useCase)
          const canEdit = is3dPrintModel && canEditUseCase(useCase.username)
          const useCaseInitialIndex = mediaContainerIndexes?.[useCase.id] ?? 0
          const isOwner = currentUsername && useCase.username === currentUsername

          return (
            <UseCaseMediaViewer
              key={useCase.id}
              useCase={useCase}
              initialMediaIndex={isGalleryView ? initialMediaIndex : useCaseInitialIndex}
              canDelete={canDelete}
              canEdit={canEdit}
              canUseLikeFeature={canUseLikeFeature}
              isFetchingPrinterTypes={isFetchingPrinterTypes}
              onApprove={onApprove}
              onDelete={onDelete}
              onEditUseCase={onEditUseCase}
              onLike={onLike}
              onReject={onReject}
              onUnlike={onUnlike}
              onUseCaseClick={onUseCaseClick}
              printerTypeOptions={printerTypeOptions}
              userIsAllowedToModerate={userIsAllowedToModerate}
              isGalleryView={isGalleryView}
              onFullscreenClick={onFullscreenClick}
              canDownloadSlicerFile={canDownloadSlicerFile}
              isOwner={isOwner}
              onShowNotification={onShowNotification}
              isUpdating={isUpdating}
              onEditingChange={onEditingChange}
            />
          )
        })}
      </div>
    </div>
  )
}

MediaContainer.propTypes = {
  canEditUseCase: func.isRequired,
  canDeleteUseCase: func.isRequired,
  canUseLikeFeature: bool.isRequired,
  isFetchingPrinterTypes: bool,
  onApprove: func.isRequired,
  onDelete: func.isRequired,
  onEditUseCase: func.isRequired,
  onLike: func.isRequired,
  onReject: func.isRequired,
  onUnlike: func.isRequired,
  onUseCaseClick: func,
  onFullscreenClick: func,
  printerTypeOptions: arrayOf(printerTypeOptionShape),
  useCases: arrayOf(useCaseShape).isRequired,
  userIsAllowedToModerate: bool.isRequired,
  initialMediaIndex: number,
  isGalleryView: bool,
  mediaContainerIndexes: shape({}),
  canDownloadSlicerFile: bool,
  currentUsername: string,
  onShowNotification: func.isRequired,
  isUpdating: bool,
  onEditingChange: func,
}

export default MediaContainer
